import {sendFinishedCustomerEvaluation} from "../../services/Technician/customerEvaluation";

export const useSendFinishedCustomerEvaluation = (
    setSendingEvaluation: (value: boolean) => void,
    setShowSignatureModal: (value:boolean) => void,
    onBack: () => void) => {

    const sendCustomerEvaluation = async (customerEvaluationDTO: any,
                                          ticketUniqueCode: string,
                                          supervisorSignature: any,
                                          technicianSignature: any) => {
        setSendingEvaluation(true);
        try {
            await sendFinishedCustomerEvaluation(customerEvaluationDTO, ticketUniqueCode, supervisorSignature, technicianSignature);
        } catch (error: any) {
            throw error;
        } finally {
            setTimeout(() => {
                setSendingEvaluation(false);
                setShowSignatureModal(false);
                onBack()
            }, 600);
        }
    };

    return {sendCustomerEvaluation};
};
